export enum WebProtocol {
  HTTP = 'http:',
  HTTPS = 'https:',
}
